import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "link-error" }
const _hoisted_2 = {
  key: 0,
  class: "simple-link--pre"
}
const _hoisted_3 = {
  key: 1,
  class: "simple-link--post"
}
const _hoisted_4 = {
  key: 2,
  class: "simple-link--description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.error)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["simple-link simple-link--error", { compact: _ctx.compact, medium: _ctx.medium, large: _ctx.large  }])
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.error), 1)
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["simple-link simple-link--content", { compact: _ctx.compact, medium: _ctx.medium, large: _ctx.large  }])
      }, [
        _renderSlot(_ctx.$slots, "default", {
          value: _ctx.displayValue,
          resolved: _ctx.resolved
        }, () => [
          (_ctx.pre)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.pre), 1))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            class: _normalizeClass(["minimal simple-link--value", {placeholder: _ctx.displayValue === null, clickable: !!_ctx.to}]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pushToRoute && _ctx.pushToRoute(...args))),
            "data-cy": "simple-link-value"
          }, _toDisplayString(_ctx.displayValue ? _ctx.stringify(_ctx.displayValue) : _ctx.emptyText || `No ${_ctx.displayField} to display`), 3),
          (_ctx.post)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.post), 1))
            : _createCommentVNode("", true),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "detail", {
            value: _ctx.displayValue,
            resolved: _ctx.resolved
          }, undefined, true)
        ], true)
      ], 2))
}